<template>
	<div id="intro">
		<b-card bg-variant="light" class="whoAmIOptions">
			<b-form-row align-h="between">
				<b-col>
					Already started an application?
				</b-col>
				<b-col>
					<b-button class="float-right" v-focus variant="primary" @click="login_click()">
						Continue your app
					</b-button>
				</b-col>
			</b-form-row>
			<hr />
			<b-form-group
				label="What type of applicant are you?"
				:label-cols="4"
				breakpoint="sm"
			>
				<b-form-radio-group
					name="applicantType"
					v-model="applicantType"
					class="pt-2"
					stacked
					required
				>
					<b-form-radio
						value="traditional"
					>
            Current high school or college student, or anyone 24 years of age or younger at the time of application.
					</b-form-radio>
					<b-form-radio
						value="nontraditional"
					>
            Anyone over the age of 24 at the time of application.
					</b-form-radio>
				</b-form-radio-group>
			</b-form-group>
			<b-form-group
				label="Are you a first-year or transfer student?"
				:label-cols="4"
				breakpoint="sm"
			>
				<b-form-radio-group
					name="studentType"
					v-model="studentType"
					class="pt-2"
					stacked
					required
					:options="[
						{ text: 'First Year', value: 'firstyear' },
						{ text: 'Transfer', value: 'transfer' }
					]"
				></b-form-radio-group>
			</b-form-group>
			<b-form-row>
				<b-col>
					<b-button
						:disabled="createAccountDisabled"
						variant="primary"
						@click.capture="createAccount"
					>
						Create Account
					</b-button>
				</b-col>
				<b-col>
					<b-button
						class="float-right"
						v-if="!continueAsGuestDisabled"
						variant="primary"
						@click.capture="continueAsGuest"
					>
						Continue as Guest
					</b-button>
				</b-col>
			</b-form-row>
			<b-form-row>
				<b-button variant="link" class="ums-text-primary" @click="back_click()"
					>Back</b-button
				>
			</b-form-row>
		</b-card>
	</div>
</template>

<script>
import bowser from "bowser";
import { mapGetters } from "vuex";

export default {
	name: "Introduction",
	data() {
		return {};
	},
	computed: {
		...mapGetters(["userType"]),
		studentType: {
			get() {
				return this.$store.getters.studentType;
			},
			set(value) {
				this.$store.dispatch("setStudentType", value);
			}
		},
		applicantType: {
			get() {
				return this.$store.getters.applicantType;
			},
			set(value) {
				this.$store.dispatch("setApplicantType", value);
			}
		},
		createAccountDisabled() {
			return !(this.applicantType && this.studentType);
		},
		continueAsGuestDisabled() {
			return (
				this.createAccountDisabled || this.applicantType !== "nontraditional"
			);
		}
	},
	methods: {
		continueAsGuest() {
			if (this.userType === "guest") {
				this.$router.push("/new-app");
			} else {
				this.$store.dispatch("create_guest_account");
			}
		},
		createAccount() {
			this.$store.commit("setUserType", "new");
			this.$router.push("/create-account");
		},
		back_click() {
			this.$router.push("/");
		},
		login_click() {
			this.$router.push("/login");
		}
	},
	watch: {
		userType(value) {
			if (value === "guest") {
				this.$router.push("/new-app");
			} else if (value === "authed") {
				this.$router.push("/applications");
			}
		}
	},
	mounted() {
		if (bowser.msie) {
			this.$store.dispatch("add_alert", {
				variant: "warning",
				msg:
					"Internet Explorer is not a supported by this application. If you are having issues, please switch browsers to Chrome, FireFox or Edge."
			});
		}
	}
};
</script>

<style scoped></style>
